module.exports = __webpack_public_path__ + "img/RachelNelson.3b4161ba.jpg";